// Service to verify and activate subscriptions after Stripe checkout

export async function verifyAndActivateSubscription(userEmail, userId) {
  try {
    const response = await fetch('/.netlify/functions/verify-subscription', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userEmail,
        userId,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to verify subscription');
    }

    return data;
  } catch (error) {
    console.error('Subscription verification error:', error);
    throw error;
  }
}